import Vue from 'vue'
import Router from 'vue-router'
import top from '@/components/Top'
import parents from '@/components/Parents'
import kittens from '@/components/Kittens'
import recruit from '@/components/Recruit'
import matureCats from '@/components/MatureCats'
import guarantee from '@/components/kittens/Guarantee'
import kitten18091001 from '@/components/kittens/Kitten18091001'
import kitten19091201 from '@/components/kittens/Kitten19091201'
import kitten19092601 from '@/components/kittens/Kitten19092601'
import kitten19092602 from '@/components/kittens/Kitten19092602'
import kitten19092603 from '@/components/kittens/Kitten19092603'
import kitten19100701 from '@/components/kittens/Kitten19100701'
import kitten19100702 from '@/components/kittens/Kitten19100702'
import kitten19100703 from '@/components/kittens/Kitten19100703'
import kitten19100704 from '@/components/kittens/Kitten19100704'
import kitten19102501 from '@/components/kittens/Kitten19102501'
import kitten19102502 from '@/components/kittens/Kitten19102502'
import kitten19102503 from '@/components/kittens/Kitten19102503'
import kitten19102504 from '@/components/kittens/Kitten19102504'
import kitten20041401 from '@/components/kittens/Kitten20041401'
import kitten20041402 from '@/components/kittens/Kitten20041402'
import kitten20041701 from '@/components/kittens/Kitten20041701'
import kitten20051301 from '@/components/kittens/Kitten20051301'
import kitten20051302 from '@/components/kittens/Kitten20051302'
import kitten20051303 from '@/components/kittens/Kitten20051303'
import kitten20051801 from '@/components/kittens/Kitten20051801'
import kitten20051802 from '@/components/kittens/Kitten20051802'
import kitten20052501 from '@/components/kittens/Kitten20052501'
import kitten20060801 from '@/components/kittens/Kitten20060801'
import kitten20060802 from '@/components/kittens/Kitten20060802'
import kitten20060803 from '@/components/kittens/Kitten20060803'
import kitten20080701 from '@/components/kittens/Kitten20080701'
import kitten20081801 from '@/components/kittens/Kitten20081801'
import kitten20081802 from '@/components/kittens/Kitten20081802'
import kitten20092101 from '@/components/kittens/Kitten20092101'
import kitten20092102 from '@/components/kittens/Kitten20092102'
import kitten20102901 from '@/components/kittens/Kitten20102901'
import kitten20102902 from '@/components/kittens/Kitten20102902'
import kitten20102903 from '@/components/kittens/Kitten20102903'
import kitten20102904 from '@/components/kittens/Kitten20102904'
import kitten20102905 from '@/components/kittens/Kitten20102905'
import kitten20120601 from '@/components/kittens/Kitten20120601'
import kitten20120602 from '@/components/kittens/Kitten20120602'
import kitten20120603 from '@/components/kittens/Kitten20120603'
import kitten20120604 from '@/components/kittens/Kitten20120604'
import kitten20122401 from '@/components/kittens/Kitten20122401'
import kitten20122402 from '@/components/kittens/Kitten20122402'
import kitten20122403 from '@/components/kittens/Kitten20122403'
import kitten20122404 from '@/components/kittens/Kitten20122404'
import kitten21031701 from '@/components/kittens/Kitten21031701'
import kitten21031702 from '@/components/kittens/Kitten21031702'
import kitten21040701 from '@/components/kittens/Kitten21040701'
import kitten21040702 from '@/components/kittens/Kitten21040702'
import kitten21042701 from '@/components/kittens/Kitten21042701'
import kitten21042702 from '@/components/kittens/Kitten21042702'
import kitten21042703 from '@/components/kittens/Kitten21042703'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'top',
      component: top
    },
    {
      path: '/parents',
      name: 'parents',
      component: parents
    },
    {
      path: '/kittens',
      name: 'kittens',
      component: kittens
    },
    {
      path: '/matureCats',
      name: 'matureCats',
      component: matureCats
    },
    {
      path: '/recruit',
      name: 'recruit',
      component: recruit
    },
    {
      path: '/kittens/guarantee',
      name: 'guarantee',
      component: guarantee
    },
    {
      path: '/kittens/18091001',
      name: '18091001',
      component: kitten18091001
    },
    {
      path: '/kittens/19091201',
      name: '19091201',
      component: kitten19091201
    },
    {
      path: '/kittens/19092601',
      name: '19092601',
      component: kitten19092601
    },
    {
      path: '/kittens/19092602',
      name: '19092602',
      component: kitten19092602
    },
    {
      path: '/kittens/19092603',
      name: '19092603',
      component: kitten19092603
    },
    {
      path: '/kittens/19100701',
      name: '19100701',
      component: kitten19100701
    },
    {
      path: '/kittens/19100702',
      name: '19100702',
      component: kitten19100702
    },
    {
      path: '/kittens/19100703',
      name: '19100703',
      component: kitten19100703
    },
    {
      path: '/kittens/19100704',
      name: '19100704',
      component: kitten19100704
    },
    {
      path: '/kittens/19102501',
      name: '19102501',
      component: kitten19102501
    },
    {
      path: '/kittens/19102502',
      name: '19102502',
      component: kitten19102502
    },
    {
      path: '/kittens/19102503',
      name: '19102503',
      component: kitten19102503
    },
    {
      path: '/kittens/19102504',
      name: '19102504',
      component: kitten19102504
    },
    {
      path: '/kittens/20041401',
      name: '20041401',
      component: kitten20041401
    },
    {
      path: '/kittens/20041402',
      name: '20041402',
      component: kitten20041402
    },
    {
      path: '/kittens/20041701',
      name: '20041701',
      component: kitten20041701
    },
    {
      path: '/kittens/20051301',
      name: '20051301',
      component: kitten20051301
    },
    {
      path: '/kittens/20051302',
      name: '20051302',
      component: kitten20051302
    },
    {
      path: '/kittens/20051303',
      name: '20051303',
      component: kitten20051303
    },
    {
      path: '/kittens/20051801',
      name: '20051801',
      component: kitten20051801
    },
    {
      path: '/kittens/20051802',
      name: '20051802',
      component: kitten20051802
    },
    {
      path: '/kittens/20052501',
      name: '20052501',
      component: kitten20052501
    },
    {
      path: '/kittens/20060801',
      name: '20060801',
      component: kitten20060801
    },
    {
      path: '/kittens/20060802',
      name: '20060802',
      component: kitten20060802
    },
    {
      path: '/kittens/20060803',
      name: '20060803',
      component: kitten20060803
    },
    {
      path: '/kittens/20080701',
      name: '20080701',
      component: kitten20080701
    },
    {
      path: '/kittens/20081801',
      name: '20081801',
      component: kitten20081801
    },
    {
      path: '/kittens/20081802',
      name: '20081802',
      component: kitten20081802
    },
    {
      path: '/kittens/20092101',
      name: '20092101',
      component: kitten20092101
    },
    {
      path: '/kittens/20092102',
      name: '20092102',
      component: kitten20092102
    },
    {
      path: '/kittens/20102901',
      name: '20102901',
      component: kitten20102901
    },
    {
      path: '/kittens/20102902',
      name: '20102902',
      component: kitten20102902
    },
    {
      path: '/kittens/20102903',
      name: '20102903',
      component: kitten20102903
    },
    {
      path: '/kittens/20102904',
      name: '20102904',
      component: kitten20102904
    },
    {
      path: '/kittens/20102905',
      name: '20102905',
      component: kitten20102905
    },
    {
      path: '/kittens/20120601',
      name: '20120601',
      component: kitten20120601
    },
    {
      path: '/kittens/20120602',
      name: '20120602',
      component: kitten20120602
    },
    {
      path: '/kittens/20120603',
      name: '20120603',
      component: kitten20120603
    },
    {
      path: '/kittens/20120604',
      name: '20120604',
      component: kitten20120604
    },
    {
      path: '/kittens/20122401',
      name: '20122401',
      component: kitten20122401
    },
    {
      path: '/kittens/20122402',
      name: '20122402',
      component: kitten20122402
    },
    {
      path: '/kittens/20122403',
      name: '20122403',
      component: kitten20122403
    },
    {
      path: '/kittens/20122404',
      name: '20122404',
      component: kitten20122404
    },
    {
      path: '/kittens/21031701',
      name: '21031701',
      component: kitten21031701
    },
    {
      path: '/kittens/21031702',
      name: '21031702',
      component: kitten21031702
    },
    {
      path: '/kittens/21040701',
      name: '21040701',
      component: kitten21040701
    },
    {
      path: '/kittens/21040702',
      name: '21040702',
      component: kitten21040702
    },
    {
      path: '/kittens/21042701',
      name: '21042701',
      component: kitten21042701
    },
    {
      path: '/kittens/21042702',
      name: '21042702',
      component: kitten21042702
    },
    {
      path: '/kittens/21042703',
      name: '21042703',
      component: kitten21042703
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      const position = {}
      // scroll to anchor by returning the selector
      if (to.hash) {
        position.selector = to.hash
        // specify offset of the element
        if (to.hash === '#anchor2') {
          position.offset = { x: 0, y: 0 }
        }
      }
      return { x: 0, y: 0 }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js